import { cn } from "@/lib/utils";
import { useTranslation } from "@/hooks/useTranslation";
import { Button } from "./ui/button";

export default function ErrorMessage({
  className,
}: React.HTMLAttributes<HTMLDivElement>) {
  const { t } = useTranslation();

  const reload = () => {
    window.location.reload();
  };

  return (
    <div className={cn("space-y-3 text-center", className)}>
      <p className="text-center">{t("components.errorMessage.title")}</p>
      <Button onClick={reload}>
        {t("components.errorMessage.refreshButton")}
      </Button>
      <p className="text-center">
        {t("components.errorMessage.persistentProblem")}{" "}
        <a href="mailto:support@shaarp.ai">
          {t("components.errorMessage.supportEmail")}
        </a>{" "}
        {t("components.errorMessage.promptResponse")}
      </p>
    </div>
  );
}
